import { INamHoc } from "../../../model/respone/category/INamHoc"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"

export const eNamHocActionTypeDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as INamHoc[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | INamHoc,
    CLOSE_EDIT_MODAL: undefined,
    
    SAVE_START: {} as INamHoc,
    SAVE_SUCCESS: {} as INamHoc,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",


}
export const eNamHocActionTypeIds = generateActionTypeIds(eNamHocActionTypeDefine, "NAM_HOC")

export type INamHocActions = IGenericActionType<typeof eNamHocActionTypeDefine, "NAM_HOC">